import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import styled, { css } from 'styled-components';
import { getUserNameInitials } from '@dealstack/frontend/admin/pages/common-ui/format/string';
import { Text } from '@mantine/core';

interface Avatar {
	className?: string;
	size?: 's' | 'm' | 'l' | 'xl';
	children: React.ReactNode;
}

const mapSizeWithFontVariant = {
	s: 'B6Medium',
	m: 'B6Medium',
	l: 'B5Medium',
	xl: 'B4Medium',
};

const Avatar = ({ className, children, size = 'xl' }: Avatar) => {
	const element =
		typeof children === 'string' ? (
			<Text size={mapSizeWithFontVariant[size]}>{getUserNameInitials(children)}</Text>
		) : (
			children
		);
	return <div className={className}>{element}</div>;
};

const Styled = styled(Avatar)`
	background-color: ${defaultTheme.v3.colors.gray[4]};
	text-transform: capitalize;
	display: flex;
	justify-content: center;
	align-items: center;

	${({ size = 'xl' }) => {
		const mapSizeWithStyle = {
			s: '1.25rem',
			m: '2rem',
			l: '3rem',
			xl: '4rem',
		};
		return css`
			width: ${mapSizeWithStyle[size]};
			height: ${mapSizeWithStyle[size]};
			border-radius: ${mapSizeWithStyle[size]};
			border-style: none;
		`;
	}}
`;

export { Styled as Avatar };
